const endpoints = {
  'dashboard-dev.luca.health': 'https://api-dev.luca.health',
  'dashboard.luca.health': 'https://api-prod.luca.health',
  localhost: 'http://localhost:8000',
  // localhost: 'https://api-prod.luca.health',

}

// export const configURL  = endpoints[window.location.hostname]

export function configURL() {
  return endpoints[window.location.hostname]
}
